<template>
  <div class="card-wrap" v-loading="loading">
    <template v-if="newList.length>0">
      <div
        class="card-item"
        v-for="(item, index) in newList"
        :key="index"
        @click="detail(item.guid)"
      >
        <p class="overh quest" :title="item.questiontitle">{{ item.questiontitle }}</p>
      </div>
    </template>
    <template v-else>
      <div class="card-empty">暂无数据</div>
    </template>
  </div>
</template>

<script>
import utils from "@mixins/utils";

export default {
  mixins: [utils],
  data() {
    return {
      loading: false,
      newList: []
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    detail(guid) {
      this.$store.dispatch("analysis/updateHits", {visitlocation: "首页-最新回答"});
      window.location.assign("/everydayQuestion/questionInfo?guid=" + guid);
    },
    getData() {
      this.loading = true
      this.$ajax({
        url: `${this.$store.state.api.webUrl}/question/recentlyList.json`,
        data: {
          pageIndex: 1,
          pageSize: 8,
        },
        callback: data => {
          this.newList = data.rows;
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  padding: 4px 30px 34px 30px;
  border-radius: 8px;
  background: #FFFFFF;
  height: 100%;

  .card-item {
    display: flex;
    align-items: center;
    margin-top: 22px;
    cursor: pointer;

    .quest {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}
</style>

